import React from 'react';
import { SiteHero } from '../../../components/site';
import { PlatformCtaBanner } from '../shared/components/PlatformCtaBanner';
import { PlatformEduIntro } from '../shared/components/PlatformEduIntro';
import { PlatformFaqs } from '../shared/components/PlatformFaqs';
import { PlatformFeatureShowcase } from '../shared/components/PlatformFeatureShowcase';
import { PlatformClosingCta } from '../shared/components/PlatformClosingCta';
import { PlatformExploreModules } from './components/PlatformExploreModules';
import { PlatformHeroVisual } from './components/PlatformHeroVisual';
import { PlatformArchitecture } from './components/PlatformArchitecture';
import { PlatformModules } from './components/PlatformModules';
import { PlatformCapabilities } from './components/PlatformCapabilities';
import { PlatformEnterprise } from './components/PlatformEnterprise';
import { PlatformApis } from './components/PlatformApis';
import { PlatformWorkflow } from './components/PlatformWorkflow';
import { platformHero, platformOverviewPremium } from './data/overview';

export const PlatformOverview: React.FC = () => (
  <div className="io-site platform-page platform-page--premium">
    <SiteHero
      title={platformHero.title}
      subtitle={platformHero.subtitle}
      titleId="platform-hero-title"
      primaryCta={platformHero.primaryCta}
      secondaryAction={
        <a href={platformHero.exploreAnchor} className="io-site-btn-secondary">
          Explore Platform
        </a>
      }
      visual={<PlatformHeroVisual />}
    />
    <PlatformEduIntro eduIntro={platformOverviewPremium.eduIntro} />
    <PlatformExploreModules />
    <PlatformArchitecture />
    <PlatformFeatureShowcase showcase={platformOverviewPremium.featureShowcase} />
    <PlatformModules />
    <PlatformCapabilities />
    <PlatformEnterprise />
    <PlatformApis />
    <PlatformWorkflow />
    <PlatformCtaBanner banner={platformOverviewPremium.ctaBanner} />
    <PlatformFaqs faqs={platformOverviewPremium.faqs} />
    <PlatformClosingCta />
  </div>
);
